import { Loader2 } from "lucide-react";

export default function SearchPending({ pending, label = "Recherche…" }) {
  if (!pending) return null;
  return (
    <span role="status" aria-live="polite" aria-atomic="true" className="inline-flex items-center gap-1.5 text-xs font-medium text-blue-700">
      <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
      {label}
    </span>
  );
}
